module.exports = __webpack_public_path__ + "static/media/zigzag.6418b830.svg";